// 定义后台接口清单
const api = {
  queryProvince:{
    method: "get",
    uri: "/rest/edu/stat/statArea/queryProvince",
    name: "查询省份信息",
  }
};


export default {
  api,
};



// WEBPACK FOOTER //
// ./src/http/api.js